import React from "react";
import { Spin, Alert } from "antd";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer } from "../../../contexts/auth/slice";
import { authSaga } from "../../../contexts/auth/saga";
import useEmbedAuth from "../useEmbedAuth";
import DashboardNew from "../../authenticatedApp/backoffice/DashboardNew";

const EmbedDashboard = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: authSaga });

  const { isReady, error } = useEmbedAuth();

  if (!isReady) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" tip="Loading dashboard..." />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 24,
        }}
      >
        <Alert
          type="error"
          message="Authentication Error"
          description={error}
          showIcon
        />
      </div>
    );
  }

  return <DashboardNew embed={true} />;
};

export default EmbedDashboard;
